import { UserPrinterDocument } from '../../user-admin';

export interface PrintHtml {
  html: string;
  printer: UserPrinterDocument;
  copies?: number;
}
